import { AppState, Auth0Provider } from '@auth0/auth0-react'
import React from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { appConfig } from '../../config'
import { endSilentSsoLogin, resolveSsoConnection } from '../../utils/authSource'

interface Props {
  children: React.ReactNode
}

export const Auth0ProviderWithNavigate = ({ children }: Props) => {
  const navigate = useNavigate()
  const { pathname } = useLocation()
  const ssoConnection = resolveSsoConnection(pathname)
  const { domain, clientId } = ssoConnection ? appConfig.auth0Sso : appConfig.auth0

  const onRedirectCallback = (appState?: AppState) => {
    endSilentSsoLogin()
    navigate(appState?.returnTo || window.location.pathname)
  }

  return (
    <Auth0Provider
      key={ssoConnection ?? 'password'}
      domain={domain}
      clientId={clientId}
      authorizationParams={{
        redirect_uri: window.location.origin,
        audience: appConfig.auth0.audience,
        ...(ssoConnection && { connection: ssoConnection }),
      }}
      onRedirectCallback={onRedirectCallback}
      cacheLocation="localstorage"
      useRefreshTokens={true}
    >
      {children}
    </Auth0Provider>
  )
}
